export const GENERATE_ENVIRONMENT_REQUEST = 'GENERATE_ENVIRONMENT_REQUEST';
export type GENERATE_ENVIRONMENT_REQUEST = typeof GENERATE_ENVIRONMENT_REQUEST;

export const GENERATE_ENVIRONMENT_REQUEST_SUCCESS =
  'GENERATE_ENVIRONMENT_REQUEST_SUCCESS';
export type GENERATE_ENVIRONMENT_REQUEST_SUCCESS = typeof GENERATE_ENVIRONMENT_REQUEST_SUCCESS;

export const GENERATE_ENVIRONMENT_REQUEST_FAILED =
  'GENERATE_ENVIRONMENT_REQUEST_FAILED';
export type GENERATE_ENVIRONMENT_REQUEST_FAILED = typeof GENERATE_ENVIRONMENT_REQUEST_FAILED;

export const INITIALIZE_WORKFLOW = 'INITIALIZE_WORKFLOW';
export type INITIALIZE_WORKFLOW = typeof INITIALIZE_WORKFLOW;

export const INITIALIZE_WORKFLOW_SUCCESS = 'INITIALIZE_WORKFLOW_SUCCESS';
export type INITIALIZE_WORKFLOW_SUCCESS = typeof INITIALIZE_WORKFLOW_SUCCESS;

export const INITIALIZE_WORKFLOW_FAILED = 'INITIALIZE_WORKFLOW_FAILED';
export type INITIALIZE_WORKFLOW_FAILED = typeof INITIALIZE_WORKFLOW_FAILED;

export const DESTROY_WORKFLOW = 'DESTROY_WORKFLOW';
export type DESTROY_WORKFLOW = typeof DESTROY_WORKFLOW;

export const UPDATE_ENVIRONMENT_STEP_STATES = 'UPDATE_ENVIRONMENT_STEP_STATES';
export type UPDATE_ENVIRONMENT_STEP_STATES = typeof UPDATE_ENVIRONMENT_STEP_STATES;

export const PATCH_ENVIRONMENT_STATE = 'PATCH_ENVIRONMENT_STATE';
export type PATCH_ENVIRONMENT_STATE = typeof PATCH_ENVIRONMENT_STATE;

export const PATCH_ENVIRONMENT_STATE_SUCCESS =
  'PATCH_ENVIRONMENT_STATE_SUCCESS';
export type PATCH_ENVIRONMENT_STATE_SUCCESS = typeof PATCH_ENVIRONMENT_STATE_SUCCESS;

export const PATCH_ENVIRONMENT_STATE_FAILED = 'PATCH_ENVIRONMENT_STATE_FAILED';
export type PATCH_ENVIRONMENT_STATE_FAILED = typeof PATCH_ENVIRONMENT_STATE_FAILED;

export const SUBMIT_ENVIRONMENT_WORKFLOW = 'SUBMIT_ENVIRONMENT_WORKFLOW';
export type SUBMIT_ENVIRONMENT_WORKFLOW = typeof SUBMIT_ENVIRONMENT_WORKFLOW;

export const SUBMIT_ENVIRONMENT_WORKFLOW_SUCCESS =
  'SUBMIT_ENVIRONMENT_WORKFLOW_SUCCESS';
export type SUBMIT_ENVIRONMENT_WORKFLOW_SUCCESS = typeof SUBMIT_ENVIRONMENT_WORKFLOW_SUCCESS;

export const SUBMIT_ENVIRONMENT_WORKFLOW_FAILED =
  'SUBMIT_ENVIRONMENT_WORKFLOW_FAILED';
export type SUBMIT_ENVIRONMENT_WORKFLOW_FAILED = typeof SUBMIT_ENVIRONMENT_WORKFLOW_FAILED;

export const SAVE_ENVIRONMENT_WORKFLOW = 'SAVE_ENVIRONMENT_WORKFLOW';
export type SAVE_ENVIRONMENT_WORKFLOW = typeof SAVE_ENVIRONMENT_WORKFLOW;

export const SAVE_ENVIRONMENT_WORKFLOW_SUCCESS =
  'SAVE_ENVIRONMENT_WORKFLOW_SUCCESS';
export type SAVE_ENVIRONMENT_WORKFLOW_SUCCESS = typeof SAVE_ENVIRONMENT_WORKFLOW_SUCCESS;

export const SAVE_ENVIRONMENT_WORKFLOW_FAILED =
  'SAVE_ENVIRONMENT_WORKFLOW_FAILED';
export type SAVE_ENVIRONMENT_WORKFLOW_FAILED = typeof SAVE_ENVIRONMENT_WORKFLOW_FAILED;

export const UPDATE_REQUEST_TYPE = 'UPDATE_REQUEST_TYPE';
export type UPDATE_REQUEST_TYPE = typeof UPDATE_REQUEST_TYPE;

export * from './steps/BinaryMapping';
export * from './steps/Environment';
export * from './steps/Eula';
export * from './steps/Infrastructure';
export * from './steps/Network';
export * from './steps/Precheck';
export * from './steps/Products';
export * from './steps/SelectProduct';
